import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-mf-control-popup',
  templateUrl: './mf-control-popup.component.html',
  styleUrls: ['./mf-control-popup.component.css']
})
export class MfControlPopupComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
    
  }

  ngOnInit() {
  }

}
